import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { cn } from '../../lib/cn';

/**
 * La tendina degli eventi, per i blocchi della email che dipendono da un
 * evento (bottone a link personale, percorso del partecipante).
 *
 * Legge solo id e nome: il resto (pagine, programma, partecipanti) lo legge
 * il motore al momento dell'invio.
 */

// La tabella eventi non e' ancora in database.types.ts (come le email_*):
// il client si forza una volta sola qui.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

interface EventoScelta {
  id: string;
  nome: string;
}

/** Le tendine hanno lo stesso aspetto dei campi di testo accanto. */
export const STILE_TENDINA =
  'w-full mt-1 h-10 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2';

function useEventi(): { eventi: EventoScelta[]; caricamento: boolean; errore: string | null } {
  const [eventi, setEventi] = useState<EventoScelta[]>([]);
  const [caricamento, setCaricamento] = useState(true);
  const [errore, setErrore] = useState<string | null>(null);

  useEffect(() => {
    let attivo = true;
    (async () => {
      const { data, error } = await db.from('eventi').select('id, nome').order('nome');
      if (!attivo) return;
      if (error) setErrore(error.message ?? 'errore imprevisto');
      else setEventi((data ?? []) as EventoScelta[]);
      setCaricamento(false);
    })();
    return () => {
      attivo = false;
    };
  }, []);

  return { eventi, caricamento, errore };
}

interface SceltaEventoProps {
  valore: string;
  onChange: (eventoId: string) => void;
  className?: string;
}

export function SceltaEvento({ valore, onChange, className }: SceltaEventoProps) {
  const { eventi, caricamento, errore } = useEventi();
  const scomparso = Boolean(valore) && !caricamento && !eventi.some((e) => e.id === valore);

  return (
    <>
      <select
        value={valore}
        onChange={(e) => onChange(e.target.value)}
        className={cn(STILE_TENDINA, className)}
        disabled={caricamento}
      >
        <option value="">{caricamento ? 'Carico gli eventi...' : "Scegli l'evento..."}</option>
        {eventi.map((e) => (
          <option key={e.id} value={e.id}>
            {e.nome}
          </option>
        ))}
        {scomparso && <option value={valore}>Evento non piu' disponibile</option>}
      </select>
      {errore && (
        <p className="text-[11px] text-red-600 mt-1">Non riesco a leggere gli eventi: {errore}</p>
      )}
      {!caricamento && !errore && eventi.length === 0 && (
        <p className="text-[11px] text-amber-700 mt-1">
          Non c'e' ancora nessun evento: crealo prima dalla sezione Eventi.
        </p>
      )}
      {scomparso && (
        <p className="text-[11px] text-amber-700 mt-1">
          L'evento scelto non esiste piu': scegline un altro.
        </p>
      )}
    </>
  );
}
